<template>
  <div class="w-100 my-2 div-progress-bar">
    <b-progress :max="maxValue" :value="value" height="8px" class="mb-2"/>
    <p>{{labelProgress}}</p>
  </div>
</template>

<script>
export default {
  name: "LoadingProgress",
  props:{
    value: Number
  },
  computed:{
    labelProgress(){
        return `${this.value}%`
    }
  },

  data(){
        return {
            maxValue: 100
        }
  },
  created(){
    if(this.max) this.maxValue = this.max
  }
};
</script>

<style lang="scss">
.div-progress-bar{
    text-align: center;
}

.div-progress-bar p{
    font-size: 15px;
    font-family: optum-sans-bold;
}

html body .div-progress-bar .progress{
    background-color: $screenSecundaryBgColor;
    border-radius: 30px;
}

html body .div-progress-bar .progress .progress-bar{
    background-color: $secundaryBgColor;
    border-radius: 30px;
}
</style>
